import './MovementFilter.scss';
import PropTypes from 'prop-types';
import Input from '../Input/Input';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

// General MovementFilter Component
const MovementFilter = ({ pagesToDisplay, updateList, totalPages }) => {
  const [textFilter, setTextFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('day');
  const [selectedPage, setSelectedPage] = useState(pagesToDisplay[0] || 1);
  const [newText, setNewText] = useState(false);

  const submitFilter = () => {
    switch (dateFilter) {
      case 'day':
        updateList({
          filter: textFilter,
          startDate: today,
          endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
          pageFilter: selectedPage,
        });
        setNewText(false);
        break;
      case 'week':
        updateList({
          filter: textFilter,
          startDate: startOfWeek,
          endDate: endOfWeek,
          pageFilter: selectedPage,
        });
        setNewText(false);
        break;
      case '':
        updateList({
          filter: textFilter,
          startDate: twoWeeksAgoMonday,
          endDate: twoWeeksAheadMonday,
          pageFilter: selectedPage,
        });
        setNewText(false);
        break;
    }
  };

  useEffect(() => {
    setNewText(true);
  }, [textFilter]);

  useEffect(() => {
    submitFilter();
  }, [selectedPage]);

  useEffect(() => {
    if (selectedPage == 1) {
      submitFilter();
    } else {
      setSelectedPage(1);
    }
  }, [dateFilter]);

  const today = new Date();

  const startOfWeek = new Date(
    new Date().setDate(
      new Date().getDate() - new Date().getDay() + (new Date().getDay() === 0 ? -6 : 1),
    ),
  );
  const endOfWeek = new Date(
    new Date().setDate(
      new Date().getDate() - new Date().getDay() + (new Date().getDay() === 0 ? -6 : 1) + 6,
    ),
  );

  const twoWeeksAgoExactly = new Date(new Date().setDate(new Date().getDate() - 14));
  const twoWeeksAgoMonday = new Date(
    twoWeeksAgoExactly.setDate(
      twoWeeksAgoExactly.getDate() -
        twoWeeksAgoExactly.getDay() +
        (twoWeeksAgoExactly.getDay() === 0 ? -6 : 1),
    ),
  );

  const twoWeeksAheadExactly = new Date(new Date().setDate(new Date().getDate() + 14));
  const twoWeeksAheadMonday = new Date(
    twoWeeksAheadExactly.setDate(
      twoWeeksAheadExactly.getDate() -
        twoWeeksAheadExactly.getDay() +
        (twoWeeksAheadExactly.getDay() === 0 ? -6 : 1),
    ),
  );

  const formatDate = date => {
    return new Intl.DateTimeFormat('en-gb', { day: '2-digit', month: 'short' }).format(
      new Date(date),
    );
  };

  return (
    <div className="movement_filter_container">
      <div className="filter_row">
        <div className="filter_input">
          <Input placeholder={'Filter results...'} value={textFilter} setValue={setTextFilter} />
        </div>
        <div className="date_selection landscape">
          <div
            className={`today button date ${dateFilter == 'day' ? 'selected' : ''} ${
              newText ? 'new_text' : ''
            }`}
            onClick={() => {
              if (dateFilter == 'day' && newText) {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setDateFilter('day');
              }
            }}
          >
            Today Only
            <div className="actual_date today">{formatDate(today)}</div>
          </div>
          <div
            className={`week button date ${dateFilter == 'week' ? 'selected' : ''}  ${
              newText ? 'new_text' : ''
            }`}
            onClick={() => {
              if (dateFilter == 'week') {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setDateFilter('week');
              }
            }}
          >
            This Week
            <div className="actual_date week">
              {formatDate(startOfWeek)} - {formatDate(endOfWeek)}
            </div>
          </div>
          <div
            className={`month button date ${dateFilter == '' ? 'selected' : ''}  ${
              newText ? 'new_text' : ''
            }`}
            onClick={() => {
              if (dateFilter == '' && newText) {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setDateFilter('');
              }
            }}
          >
            Everything
            <div className="actual_date month">
              {formatDate(twoWeeksAgoMonday)} - {formatDate(twoWeeksAheadMonday)}
            </div>
          </div>
        </div>
        <div className="date_selection portrait">
          <div
            className={`today button date ${dateFilter == 'day' ? 'selected' : ''} ${
              newText ? 'new_text' : ''
            }`}
            onClick={() => {
              if (dateFilter == 'day' && newText) {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setDateFilter('day');
              }
            }}
          >
            Today
            <div className="actual_date today">{formatDate(today)}</div>
          </div>
          <div
            className={`week button date ${dateFilter == 'week' ? 'selected' : ''}  ${
              newText ? 'new_text' : ''
            }`}
            onClick={() => {
              if (dateFilter == 'week' && newText) {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setDateFilter('week');
              }
            }}
          >
            Week
            <div className="actual_date week">
              {formatDate(startOfWeek)} - {formatDate(endOfWeek)}
            </div>
          </div>
          <div
            className={`month button date ${dateFilter == '' ? 'selected' : ''}  ${
              newText ? 'new_text' : ''
            }`}
            onClick={() => {
              if (dateFilter == '' && newText) {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setDateFilter('');
              }
            }}
          >
            All
            <div className="actual_date month">
              {formatDate(twoWeeksAgoMonday)} - {formatDate(twoWeeksAheadMonday)}
            </div>
          </div>
        </div>
      </div>
      <div className="pagination">
        <div
          className="prev button"
          data-testid="prev_button"
          onClick={() => {
            if (newText) {
              selectedPage == 1 ? submitFilter() : setSelectedPage(1);
            } else {
              setSelectedPage(Math.max(selectedPage - 1, 1));
            }
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        {pagesToDisplay.map(pageNumber => (
          <div
            className={`page button ${selectedPage == pageNumber ? 'selected' : ''}`}
            key={`page_button_${pageNumber}`}
            onClick={() => {
              if (newText) {
                selectedPage == 1 ? submitFilter() : setSelectedPage(1);
              } else {
                setSelectedPage(pageNumber);
              }
            }}
          >
            {pageNumber}
          </div>
        ))}
        {pagesToDisplay.length < 10 &&
          Array(10 - pagesToDisplay.length)
            .fill()
            .map((item, index) => (
              <div
                className="page button "
                key={`empty_button_${index}`}
                data-testid={`empty_button_${index}`}
                onClick={() => {
                  if (newText) {
                    selectedPage == 1 ? submitFilter() : setSelectedPage(1);
                  } else if (selectedPage != pagesToDisplay[pagesToDisplay.length - 1]) {
                    setSelectedPage(pagesToDisplay[pagesToDisplay.length - 1]);
                  }
                }}
              ></div>
            ))}
        <div
          className="next button"
          data-testid="next_button"
          onClick={() => {
            if (newText) {
              selectedPage == 1 ? submitFilter() : setSelectedPage(1);
            } else {
              setSelectedPage(Math.min(selectedPage + 1, totalPages));
            }
          }}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
    </div>
  );
};

MovementFilter.propTypes = {
  pagesToDisplay: PropTypes.array,
  updateList: PropTypes.func,
  totalPages: PropTypes.number,
};

export default MovementFilter;
